// TODO: Move this code into the cart module when ni.js is deprecated


(function($) {
    window.initCart = function() {

        var basketSelector = '#basketLink';
        var basketNode = $(basketSelector);

        if (basketNode && !Util.isShopPage()) {
            $(document).on('click', basketSelector, function () {
                if (!basketNode.data('bs.popover')) {

                    $('body,a,button').css('cursor', 'wait');

                    $.getJSON('/' + Util.getLang() + '/?eID=ajaxbridge&action=basket&' + Util.getBasketCount(), function (data) {
                        basketNode
                            .popover({
                                html: true,
                                placement: function (context, source) {
                                    $(context).removeClass('bottom bottomright');

                                    var offsetRight = $(window).width() - $(source).offset().left;
                                    if (offsetRight < 189) {
                                        return "bottomright";
                                    }

                                    return "bottom";
                                },
                                title: $(this).data('title'),
                                content: data.content,
                                trigger: 'manual',
                                animation: false
                            })
                            .exclusivePopover({group: 'metanav'})
                            .popover('toggle');

                        $('body,a,button').css('cursor', '');

                    });
                } else {
                    basketNode.popover('toggle');
                }
                return false;
            });
        }
    };

})(jQuery);
